import { Injectable } from '@angular/core';
import { AplicativoUsuarioDTO } from '../modelado/dto/aplicativo-usuario-DTO';


import { UnidadAdministrativa } from '../modelado/sar/unidad-administrativa';
import { Aplicativo } from '../modelado/sar/aplicativo';


/**
 * jp
 */
@Injectable()
export class DatosSesionService {

  /**
   * Es la unidad del aplicativo seleccionado
   */
  unidadSeleccionadaAplicativo: UnidadAdministrativa;

  menuUsuario: any[];

  constructor( ) { }

  errorEditandoDisponibilidadPlanificacion: boolean;
  exitoGuardandoDisponibildadPlanificacion: boolean;
  exitoCreadoDisponibilidadPlanificacion: any;

  errorEditandoJefeUnidad: boolean;
  exitoGuardandoJefeUnidad: boolean;
  exitoCreadoJefeUnidad: any;

  errorEditandoRequerimiento: boolean;
  exitoGuardandoRequerimiento: boolean;
  exitoCreadoRequerimiento: any;

  nombrePlanificacionActual: string;
  idPlanificacionActual: number;//almacena la planificación seleccionada
  idDisponibilidadPlanificacion:number;//almacena el id de la disponibilidad que se va a asociar
  fechaCreacionPlanificacion: Date;//almacena el mes que se crea la planificación osea un mes antes del real
  numeroMesPlanificacion: number;//almacena el número del mes de la planificacion siendo 0 = Enero 11=diciembre
  tipoVistaActual:string;//almacena la vista actual en el calendario de analista de catering


  public guardarTipoVistaActual(tipoVistaActual){
    console.log("Guarda "+tipoVistaActual);
    sessionStorage.setItem('tipoVistaActual', tipoVistaActual);
  }
  public getTipoVistaActual(): string {
    console.log("Recupera "+Number(sessionStorage.getItem('tipoVistaActual')));
    return sessionStorage.getItem('tipoVistaActual');
  }


  public guardarNumeroMesPlanificacion(numeroMesPlanificacion){
    console.log("Guarda "+numeroMesPlanificacion);
    sessionStorage.setItem('numeroMesPlanificacion', numeroMesPlanificacion);
  }
  public getNumeroMesPlanificacion(): number {
    console.log("Recupera "+Number(sessionStorage.getItem('numeroMesPlanificacion')));
    return Number(sessionStorage.getItem('numeroMesPlanificacion'));
  }

  public guardarFechaCreacionPlanificacion(fechaCreacionPlanificacion){
    console.log("Guarda "+fechaCreacionPlanificacion);
    sessionStorage.setItem('fechaCreacionPlanificacion', fechaCreacionPlanificacion);
  }
  public getFechaCreacionPlanificacion(): Date {
    console.log("Recupera "+Number(sessionStorage.getItem('fechaCreacionPlanificacion')));
    return new Date(sessionStorage.getItem('fechaCreacionPlanificacion'));
  }

  public guardarNombrePlanificacionActual(nombrePlanificacionActual){
    console.log("Guarda "+nombrePlanificacionActual);
    sessionStorage.setItem('nombrePlanificacionActual', nombrePlanificacionActual);
  }
  public getNombrePlanificacionActual(): string {
    console.log("Recupera "+Number(sessionStorage.getItem('nombrePlanificacionActual')));
    return sessionStorage.getItem('nombrePlanificacionActual');
  }

  public guardarIdDisponibilidadPlanificacion(idDisponibilidadP){
    console.log("Guarda "+idDisponibilidadP);
    sessionStorage.setItem('idDisponibilidadPlanificacion', idDisponibilidadP);
  }
  public getDisponibilidadPlanificacion(): number {
    console.log("Recupera "+Number(sessionStorage.getItem('idDisponibilidadPlanificacion')));
    return Number(sessionStorage.getItem('idDisponibilidadPlanificacion'));
  }

  public guardarIdPlanificacionActual(idPlanificacionA){
    console.log("Guarda "+idPlanificacionA);
    sessionStorage.setItem('idPlanificacionActual', idPlanificacionA);
  }
  public getPlanificacionActual(): number {
    console.log("Recupera "+Number(sessionStorage.getItem('idPlanificacionActual')));
    return Number(sessionStorage.getItem('idPlanificacionActual'));
  }

  public guardarUnidad(idUnidadS){
    console.log("Guardar "+idUnidadS );
    sessionStorage.setItem('idUnidadSeleccionada', idUnidadS);
  }

  public getUnidadSeleccionada(): number {
    console.log("Recuperar "+sessionStorage.getItem('idUnidadSeleccionada'));
    return Number(sessionStorage.getItem('idUnidadSeleccionada'));
  }

  public guardarDatosSesion(respuestaSAR: AplicativoUsuarioDTO) {

    let uidActual = this.getUid();
    localStorage.setItem('data', JSON.stringify(respuestaSAR));

  }



  public getData() {
    let datos = JSON.parse(localStorage.getItem('data'));
    return datos;
  }

  public existenDatos() {
    if (localStorage.getItem('data')) {
      return true;
    } else {
      return false;
    }
  }
  public sessionGoogle() {
    if (localStorage.getItem('sesion_google')) {
      return true;
    } else {
      return false;
    }
  }
  public getDatoSessionGoogle() {
    let datoSesion = JSON.parse(localStorage.getItem('sesion_google'));
    return datoSesion;
  }

  public getMenu() {
    let menu = JSON.parse(localStorage.getItem('menu'));
    return menu;
  }

  public getCorreoUsuario() {
    try {
      let respuesta: AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
      let correo = respuesta.usuario.correo;
      return correo;

    } catch (error) {
      console.error('Error getCorreoUsuario ' + error);
    }
  }

  public getUsuario() {
    try {
      // console.log('busca informacion usuario session ');
      let respuesta: AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
      // console.log('armo el obj usuario ' + JSON.stringify(respuesta));
      let usu = respuesta.usuario;
      return usu;

    } catch (error) {
      console.error('Error getUsuario Detalle:... ' + error);
    }
  }


  public getUid() {
    let menu = JSON.parse(localStorage.getItem('uid'));
    return menu;
  }

  public getMenuSGA() {
    // let menu = JSON.parse(localStorage.getItem('menu'));
    // let model = [];
    // menu.forEach(item => {
    //   let hijos = [];
    //   if (item.hijos.length > 0) {
    //     item.hijos.forEach(hijo => {
    //       let hijos2 = [];
    //       if (hijo.hijos.length > 0) {
    //         hijo.hijos.forEach(hijo2 => {

    //           hijos2.push({ label: hijo2.etiqueta, icon: hijo2.icono, routerLink: [hijo2.url] });
    //         }
    //         );
    //       }
    //       if (hijos2.length > 0)
    //         hijos.push({ label: hijo.etiqueta, icon: hijo.icono, items: hijos2 });
    //       else
    //         hijos.push({ label: hijo.etiqueta, icon: hijo.icono, routerLink: [hijo.url] });

    //     }
    //     );

    //   }

    //   if (hijos.length > 0)
    //     model.push({ label: item.etiqueta, icon: item.icono, items: hijos });
    //   else
    //     model.push({ label: item.etiqueta, icon: item.icono, routerLink: [item.url] });
    // });
    // return model;
  }

  public getIdUnidad() {
    try {
      let idUnidad: number = JSON.parse(localStorage.getItem('idUnidad'));
      return idUnidad;
    } catch (error) {
      return -1;
    }

  }

  getUsuarioLDAP(): any {
    return JSON.parse(localStorage.getItem('usuarioLDAP'));
  }

  setUsuarioLDAP(usuarioLDAP: any) {
    localStorage.setItem('usuarioLDAP', JSON.stringify(usuarioLDAP));
  }

  getAplicacionesDeUsuarioGrouper(): any {
    return JSON.parse(localStorage.getItem('aplicacionesDeUsuarioGrouper'));
  }

  setAplicacionesDeUsuarioGrouper(aplicaciones: any) {
    localStorage.setItem('aplicacionesDeUsuarioGrouper', JSON.stringify(aplicaciones));
  }

  getMenusGrouperPorApp(aplicativo: string): any {
    return JSON.parse(localStorage.getItem('enusGrouperPorApp_' + aplicativo));
  }

  setMenusGrouperPorApp(datos: any, aplicativo: string) {
    localStorage.setItem('enusGrouperPorApp_' + aplicativo, JSON.stringify(datos));
  }

  getAplicacionesGASPorCategoria(categoria: string): any {
    return JSON.parse(localStorage.getItem('aplicacionesCategoria_' + categoria));
  }

  setAplicacionesGASPorCategoria(grupos: any, categoria: string) {
    localStorage.setItem('aplicacionesCategoria_' + categoria, JSON.stringify(grupos));
  }

  getMenusGASPorAplicativoYUnidad(aplicativo: string, unidad: string): any {
    //console.log(JSON.parse(localStorage.getItem('menusAplicativo_' + aplicativo + '_' + unidad)));
    //console.log("respuesta del datos sesion service ts");

    //return JSON.parse('menusAplicativo_' + aplicativo + '_' + unidad);

    // if (localStorage.length > 0) {
    //   console.log(localStorage);
    // } else {
    //   console.log("No hay elementos");
    // }
    return JSON.parse(localStorage.getItem('menusAplicativo_' + aplicativo + '_' + unidad));

  }

  setMenusGASPorAplicativo(grupos: any, aplicativo: string, unidad: string) {
    localStorage.setItem('menusAplicativo_' + aplicativo + '_' + unidad, JSON.stringify(grupos));
  }


  public getNombreCompleto() {
    let data:AplicativoUsuarioDTO  = JSON.parse(localStorage.getItem('data'));
    return data.usuario.nombre;
  }

  public getIdentificacionUsuario() {
    let data:AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
    return data.usuario.identificacion;
  }

  public getMenuPorRol() {
    let datos = JSON.parse(localStorage.getItem('data'));
    let idRol = JSON.parse(localStorage.getItem('idRol'));
    for (let rol of datos.usuario.aplicaciones[0].roles) {
      if (rol.id == idRol) {
        return rol.menus;
      }
    }
  }



  public getToken(): string {

    try {
      let data: AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
      let token = data.token;
      return token;

    } catch (error) {
      console.error('Error getToken ' + error);
    }

  }

  public setToken(token: string) {

    try {

      // console.log(' ------------------------> modificando token nuevo  ' + token);


      let respuesta: any = JSON.parse(localStorage.getItem('data'));
      // let correo = respuesta.usuario.correo;
      respuesta.token = token;
      localStorage.setItem('data', JSON.stringify(respuesta));
      // localStorage.setItem('data2', JSON.stringify(respuesta));
      // localStorage.setItem('data3', token);
    } catch (error) {
      console.error('Error setToken ' + error);
    }

  }


  public getAplicativo(): Aplicativo {
    let data: AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
    let appl = data.aplicativo;
    return data.aplicativo;
  }


  public getUnidadesAdministrativasUusuairo(): UnidadAdministrativa[] {
    let data: AplicativoUsuarioDTO = JSON.parse(localStorage.getItem('data'));
    let appl = data.listaUnidades ;
    return appl ;
  }

  /**
   * Permite limpiar
   */
  public limpiar(){
    localStorage.clear();
    this.unidadSeleccionadaAplicativo = null;
    this.menuUsuario = [];
  }







}
